import { render } from "./ViewTag.vue?vue&type=template&id=c3b6faf8&scoped=true"
import script from "./ViewTag.vue?vue&type=script&lang=js"
export * from "./ViewTag.vue?vue&type=script&lang=js"

import "./ViewTag.vue?vue&type=style&index=0&id=c3b6faf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b6faf8"]])

export default __exports__